import { useContext, useEffect, useState } from "react";
import toast from "../../utils/toast";
import { useLocation } from "react-router";
import { Context } from "../../Context/Context";
import { postsApi, uploadApi } from "../../services";
import BookingPanel from "../booking/BookingPanel";
import RankEditor from "../rank/RankEditor";
import AccCredHistory from "../booking/AccCredHistory";
import { rankLabelOf, reputationLevel } from "../../utils/rank";
import "./singlePost.css";

export default function SinglePost() {
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const [post, setPost] = useState({});
  // const PF = "http://localhost:5000/images/";
  const PF = "https://backend.hoanglecf.com/images/";
  const { user } = useContext(Context);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [price, setPrice] = useState("");
  const [priceValue, setPriceValue] = useState(0);
  const [photo, setPhoto] = useState("");
  const [listImages, setListImages] = useState([]);
  const [updateMode, setUpdateMode] = useState(false);
  const [thumb, setThumb] = useState("");
  // Rank & uy tín — chỉ áp dụng cho acc Liên Quân
  const [rankInfo, setRankInfo] = useState({ rank: null, reputation: null });
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [dragIndex, setDragIndex] = useState(null);
  // Tab của khối cuối trang: ảnh chi tiết | lịch sử đổi user/pass acc
  const [galleryTab, setGalleryTab] = useState("images");

  // console.log("listImages", listImages);
  useEffect(() => {
    const getPost = async () => {
      try {
        const postData = await postsApi.getPostById(path);
        setPost(postData);
        setTitle(postData.title);
        setDesc(postData.desc);
        setPrice(postData.price);
        setPriceValue(postData.priceValue || 0);
        setListImages(postData.listImages);
        setThumb(postData.thumb);
        setPhoto(postData.photo || "");
        // Post cũ có rank rỗng {tier:null,...} — quy về null cho gọn state
        setRankInfo({
          rank: postData.rank?.tier ? postData.rank : null,
          reputation: postData.reputation ?? null,
        });
      } catch (error) {
        console.error('Error fetching post:', error);
      }
    };
    getPost();
  }, [path]);

  const handlePostUpdated = (fields) => {
    setPost((prev) => ({ ...prev, ...fields }));
  };

  const handleDelete = async () => {
    try {
      await postsApi.deletePost(post._id, user.username);
      window.location.replace("/");
    } catch (err) {}
  };

  const handleUpdate = async () => {
    try {
      const updateData = {
        username: user.username,
        title,
        desc,
        price,
        priceValue: Number(priceValue) || 0,
        listImages,
        photo,
      };

      if (thumb === "lienquan") {
        updateData.rank = rankInfo.rank;
        updateData.reputation = rankInfo.reputation;
      }

      await postsApi.updatePost(post._id, updateData);
      setPost(prev => ({ ...prev, photo, ...(thumb === "lienquan" ? rankInfo : {}) }));
      setUpdateMode(false);
    } catch (err) {}
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const tempName = `${Date.now()}-${file.name}`;
      const res = await uploadApi.uploadFile(file, tempName);
      if (res && res.filename) {
        setPhoto(res.filename);
      }
    } catch (error) {
      console.error('Error uploading cover photo:', error);
      toast.error('Có lỗi khi upload ảnh chính. Vui lòng thử lại.');
    }
  };

  const handleRemoveFile = (index) => {
    const newFiles = [...listImages];
    newFiles.splice(index, 1);
    setListImages(newFiles);
  };

  // Upload nhiều file → trả về mảng filename theo đúng thứ tự chọn
  const uploadFiles = async (files) => {
    const uploadPromises = files.map(async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      const response = await fetch("https://backend.hoanglecf.com/api/upload", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error("Upload failed");
      const data = await response.json();
      return data.filename;
    });
    return Promise.all(uploadPromises);
  };

  // Thêm ảnh vào cuối danh sách
  const handleAddImages = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    try {
      const uploaded = await uploadFiles(files);
      setListImages((prev) => [...prev, ...uploaded]);
      e.target.value = '';
    } catch (error) {
      console.error('Error uploading images:', error);
      toast.error('Có lỗi khi upload ảnh. Vui lòng thử lại.');
    }
  };

  // Chèn ảnh vào vị trí cụ thể (sau ảnh thứ `position`)
  const handleInsertAt = async (e, position) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    try {
      const uploaded = await uploadFiles(files);
      setListImages((prev) => {
        const arr = [...prev];
        arr.splice(position, 0, ...uploaded);
        return arr;
      });
      e.target.value = '';
      toast.success('Đã chèn ảnh vào vị trí đã chọn');
    } catch (error) {
      console.error('Error inserting images:', error);
      toast.error('Có lỗi khi chèn ảnh. Vui lòng thử lại.');
    }
  };

  // Di chuyển ảnh trong danh sách
  const moveImage = (from, to) => {
    if (to < 0 || to >= listImages.length || from === to) return;
    setListImages((prev) => {
      const arr = [...prev];
      const [item] = arr.splice(from, 1);
      arr.splice(to, 0, item);
      return arr;
    });
  };

  // Kéo - thả để sắp xếp
  const handleDragStart = (index) => setDragIndex(index);
  const handleDragOver = (e) => e.preventDefault();
  const handleDropOn = (index) => {
    if (dragIndex === null) return;
    moveImage(dragIndex, index);
    setDragIndex(null);
  };

  const handleImageClick = (img) => {
    setSelectedImage(img);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  return (
    <div className="single-post-page">
      <div className="single-post-container">
        {/* Header Section */}
        <div className="single-post-header">
          <div className="post-header-info">
            <h1 className="post-title-main">
              {thumb === "guide" ? "Chi tiết hướng dẫn" : "Chi tiết tài khoản"}
            </h1>
            <p className="post-subtitle">
              {thumb === "guide" ? "Xem và chỉnh sửa hướng dẫn" : "Xem và chỉnh sửa thông tin tài khoản"}
            </p>
          </div>
          <div className="post-header-actions">
            {updateMode ? (
              <div className="action-buttons">
                <button className="btn btn-success" onClick={handleUpdate}>
                  <i className="fas fa-check"></i>
                  <span>Lưu thay đổi</span>
                </button>
                <button className="btn btn-secondary" onClick={() => setUpdateMode(false)}>
                  <i className="fas fa-times"></i>
                  <span>Hủy</span>
                </button>
              </div>
            ) : (
              <div className="action-buttons">
                <button className="btn btn-primary" onClick={() => setUpdateMode(true)}>
                  <i className="fas fa-edit"></i>
                  <span>Chỉnh sửa</span>
                </button>
                {thumb !== "guide" && (
                  <button className="btn btn-danger" onClick={handleDelete}>
                    <i className="fas fa-trash"></i>
                    <span>Xóa</span>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="single-post-content">
          {/* Left Section - Main Image */}
          <div className="post-image-section">
            <div className="main-image-container">
              {photo ? (
                <img src={PF + photo} alt="Account Preview" className="main-image" />
              ) : (
                <div className="no-image-placeholder">
                  <i className="fas fa-image"></i>
                  <span>Không có ảnh</span>
                </div>
              )}
              
              {updateMode && (
                <div className="photo-edit-overlay">
                  <label htmlFor="photoUploadInput" className="edit-photo-btn">
                    <i className="fas fa-camera"></i>
                    <span>Thay ảnh chính</span>
                  </label>
                  <input
                    id="photoUploadInput"
                    type="file"
                    accept="image/*"
                    onChange={handlePhotoChange}
                    style={{ display: 'none' }}
                  />
                  {photo && (
                    <button 
                      type="button" 
                      className="delete-photo-btn"
                      onClick={() => setPhoto("")}
                    >
                      <i className="fas fa-trash"></i>
                      <span>Xóa ảnh</span>
                    </button>
                  )}
                </div>
              )}

              <div className="image-overlay">
                <div className="account-badge">
                  <span className="badge-text">hoanglecf.com</span>
                </div>
                <div className="account-id">
                  <span>MS: {title?.split(' - ')[0] || 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Account Details */}
          <div className="post-details-section">
            <div className="details-card">
              <div className="card-header">
                <h3>Thông tin tài khoản</h3>
              </div>
              <div className="card-body">
                {/* Account ID */}
                <div className="detail-item">
                  <label className="detail-label">
                    <i className="fas fa-id-card"></i>
                    {thumb === "guide" ? "Mục:" : "Acc chuyên:"}
                  </label>
                  {updateMode ? (
                    <div className="input-group">
                      <input
                        type="text"
                        value={title}
                        className="form-input"
                        autoFocus
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Nhập mã số tài khoản"
                      />
                    </div>
                  ) : (
                    <div className="detail-value">{title}</div>
                  )}
                </div>

                {/* Account VIP */}
                <div className="detail-item">
                  <label className="detail-label">
                    <i className="fas fa-crown"></i>
                    {thumb === "guide" ? "Link:" : "Acc vip:"}
                  </label>
                  {updateMode ? (
                    <div className="input-group">
                      <textarea
                        className="form-textarea"
                        value={desc}
                        onChange={(e) => setDesc(e.target.value)}
                        placeholder="Nhập thông tin VIP"
                        rows="3"
                      />
                    </div>
                  ) : (
                    <div className="detail-value">{desc}</div>
                  )}
                </div>

                {/* Rental Price */}
                <div className="detail-item">
                  <label className="detail-label">
                    <i className="fas fa-dollar-sign"></i>
                    {thumb === "guide" ? "Mô tả:" : "Giá thuê:"}
                  </label>
                  {updateMode ? (
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-input"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        placeholder="VD: 3h/30.000"
                      />
                    </div>
                  ) : (
                    <div className="detail-value price-value">{price}₫</div>
                  )}
                </div>

                {/* Price Value (số) — chỉ hiện với acc, không phải guide */}
                {thumb !== "guide" && (
                  <div className="detail-item">
                    <label className="detail-label">
                      <i className="fas fa-coins"></i>
                      Giá tính tiền (₫):
                    </label>
                    {updateMode ? (
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-input"
                          value={priceValue}
                          min="0"
                          step="1000"
                          onChange={(e) => setPriceValue(e.target.value)}
                          placeholder="VD: 30000"
                        />
                      </div>
                    ) : (
                      <div className="detail-value price-value">
                        {priceValue ? Number(priceValue).toLocaleString("vi-VN") + "₫" : "Chưa set"}
                      </div>
                    )}
                  </div>
                )}

                {/* Account Type */}
                <div className="detail-item">
                  <label className="detail-label">
                    <i className="fas fa-gamepad"></i>
                    Loại tài khoản:
                  </label>
                  <div className="detail-value">
                    <span className={`type-badge ${thumb}`}>
                      {thumb === "crossFire" ? "CrossFire" : 
                       thumb === "lienquan" ? "Liên Quân" : 
                       thumb === "freefire" ? "Free Fire" :
                       thumb === "guide" ? "Hướng dẫn" : "Khác"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Rank & uy tín — chỉ với acc Liên Quân */}
            {thumb === "lienquan" && (
              <div className="details-card">
                <div className="card-header">
                  <h3>Rank &amp; uy tín</h3>
                </div>
                <div className="card-body">
                  {updateMode ? (
                    <RankEditor value={rankInfo} onChange={setRankInfo} />
                  ) : (
                    <>
                      <div className="detail-item">
                        <label className="detail-label">
                          <i className="fas fa-medal"></i>
                          Rank:
                        </label>
                        <div className="detail-value">
                          {rankLabelOf(rankInfo.rank) || "Chưa xếp hạng"}
                        </div>
                      </div>
                      <div className="detail-item">
                        <label className="detail-label">
                          <i className="fas fa-shield-alt"></i>
                          Uy tín:
                        </label>
                        <div className="detail-value">
                          {rankInfo.reputation === null || rankInfo.reputation === undefined ? (
                            "Chưa đánh giá"
                          ) : (
                            <>
                              <span className="rep-meter">
                                <span
                                  className="rep-meter__fill"
                                  style={{
                                    width: `${rankInfo.reputation}%`,
                                    background: reputationLevel(rankInfo.reputation)?.color,
                                  }}
                                />
                              </span>
                              <span style={{ color: reputationLevel(rankInfo.reputation)?.color }}>
                                {rankInfo.reputation}/100 · {reputationLevel(rankInfo.reputation)?.label}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Image Gallery Section */}
        <div className="image-gallery-section">
          <div className="gallery-header">
            <div className="detail-tabs">
              <button
                type="button"
                className={`detail-tab ${galleryTab === "images" ? "active" : ""}`}
                onClick={() => setGalleryTab("images")}
              >
                <i className="fas fa-images"></i>
                <span>Ảnh chi tiết</span>
              </button>
              {thumb !== "guide" && (
                <button
                  type="button"
                  className={`detail-tab ${galleryTab === "history" ? "active" : ""}`}
                  onClick={() => setGalleryTab("history")}
                >
                  <i className="fas fa-history"></i>
                  <span>Lịch sử user/pass</span>
                </button>
              )}
            </div>
            {galleryTab === "images" && (
              <div className="gallery-header-right">
                <span className="gallery-count">{listImages.length} ảnh</span>
                {updateMode && (
                  <label className="add-images-btn">
                    <i className="fas fa-plus"></i>
                    <span>Thêm ảnh</span>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleAddImages}
                      style={{ display: 'none' }}
                    />
                  </label>
                )}
              </div>
            )}
          </div>
          {galleryTab === "images" ? (
            <>
            {updateMode && listImages && listImages.length > 0 && (
              <p className="gallery-hint">
                <i className="fas fa-arrows-alt"></i> Kéo-thả ảnh để sắp xếp, hoặc dùng nút mũi tên. Nút <i className="fas fa-plus"></i> để chèn ảnh ngay sau vị trí đó.
              </p>
            )}
            {listImages && listImages.length > 0 ? (
              <div className="image-gallery">
                {listImages.map((img, index) => (
                  <div
                    key={index}
                    className={`gallery-item ${updateMode ? 'draggable' : ''} ${dragIndex === index ? 'dragging' : ''}`}
                    draggable={updateMode}
                    onDragStart={() => updateMode && handleDragStart(index)}
                    onDragOver={updateMode ? handleDragOver : undefined}
                    onDrop={() => updateMode && handleDropOn(index)}
                    onDragEnd={() => setDragIndex(null)}
                  >
                    <img
                      src={PF + img}
                      alt={`Detail ${index + 1}`}
                      onClick={() => !updateMode && handleImageClick(img)}
                      className="gallery-image"
                    />
                    <span className="image-order-badge">{index + 1}</span>
                    {updateMode && (
                      <div className="gallery-overlay edit">
                        <div className="reorder-controls">
                          <button
                            type="button"
                            className="move-btn"
                            title="Di chuyển sang trái"
                            disabled={index === 0}
                            onClick={() => moveImage(index, index - 1)}
                          >
                            <i className="fas fa-arrow-left"></i>
                          </button>
                          <button
                            type="button"
                            className="move-btn"
                            title="Di chuyển sang phải"
                            disabled={index === listImages.length - 1}
                            onClick={() => moveImage(index, index + 1)}
                          >
                            <i className="fas fa-arrow-right"></i>
                          </button>
                        </div>
                        <label className="insert-btn" title="Chèn ảnh sau ảnh này">
                          <i className="fas fa-plus"></i>
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={(e) => handleInsertAt(e, index + 1)}
                            style={{ display: 'none' }}
                          />
                        </label>
                        <button
                          type="button"
                          className="remove-image-btn"
                          title="Xóa ảnh"
                          onClick={() => handleRemoveFile(index)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    )}
                    {!updateMode && (
                      <div className="gallery-overlay">
                        <button
                          type="button"
                          className="view-image-btn"
                          onClick={() => handleImageClick(img)}
                        >
                          <i className="fas fa-search-plus"></i>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-images-placeholder">
                <i className="fas fa-images"></i>
                <p>Chưa có ảnh chi tiết</p>
                {updateMode && (
                  <label className="add-images-btn primary">
                    <i className="fas fa-plus"></i>
                    <span>Thêm ảnh đầu tiên</span>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleAddImages}
                      style={{ display: 'none' }}
                    />
                  </label>
                )}
              </div>
            )}
            </>
          ) : (
            <AccCredHistory postId={post._id} />
          )}
        </div>

        {/* Sổ thuê acc — chỉ áp dụng cho acc, bỏ qua hướng dẫn */}
        {post?._id && thumb !== "guide" && (
          <BookingPanel
            post={post}
            username={user?.username}
            onPostUpdated={handlePostUpdated}
          />
        )}

        {/* Image Modal */}
        {showImageModal && selectedImage && (
          <div className="image-modal" onClick={closeImageModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeImageModal}>
                <i className="fas fa-times"></i>
              </button>
              <img src={PF + selectedImage} alt="Full size" className="modal-image" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
